import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typo, useLazyLoadImage } from 'tmt-ui-kit';

import Link from '~/components/Link/Link';

const Title = styled(Typo.HeaderTwo)`
  font-size: 24px !important;
  margin: 16px auto;
`;

const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 32px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const BookContainer = styled.div`
  width: 25%;
  display: inline-block;
  box-sizing: border-box;
  margin-bottom: 10px;
  @media (max-width: 600px) {
    width: 100%;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
  &:nth-child(4n+1) {
    clear: both;
    @media (min-width: 601px) {
      padding-right: 6.67px;
    }
  }
  &:nth-child(4n+2), &:nth-child(4n+3) {
    @media (min-width: 601px) {
      padding-left: 3.33px;
      padding-right: 3.33px;
    }
  }
  &:nth-child(4n+4) {
    @media (min-width: 601px) {
      padding-left: 6.67px;
    }
  }
`;

const Book = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-bottom: 75%;
  border-radius: 6px;
`;

const Image = styled.img`
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  top: -50%;
  opacity: 0;
  transition: ${props => props.theme.imageTransition};
`;

const BlackPlane = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
`;

const Text = styled.p`
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: white;
  margin: auto;
  padding: 0 8px;
  line-height: 32px;
`;

const EBook = props => {
  const { ebook } = props;
  const imgRef = useRef();
  useLazyLoadImage(imgRef);
  return (
    <BookContainer key={ebook.name}>
      <Link to={`/ebook/${ebook.slug}`}>
        <Book>
          <Image
            ref={imgRef}
            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
            data-src={`${ebook.image_url_without_type}.jpg`}
            alt={ebook.name}
          />
          <BlackPlane>
            <Text>{ebook.name}</Text>
          </BlackPlane>
        </Book>
      </Link>
    </BookContainer>
  );
};

const EBooks = (props) => {
  const { ebooks } = props;
  return (
    <Fragment>
      <Title>Downloadable Contents</Title>
      <Box>
        {ebooks.map(ebook => <EBook ebook={ebook} />)}
      </Box>
    </Fragment>
  );
};

EBooks.propTypes = {
  ebooks: PropTypes.arrayOf(PropTypes.object)
};

export default EBooks;
